// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import resetcss from './assets/css/reset.css';
import css from './assets/css/style.css';
import axios from 'axios'
import VueLoading from 'vue-loading-template'
import Vuex from 'vuex'
import store from "./store";
import VueCompositionApi from '@vue/composition-api';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios

Vue.use(VueCompositionApi)
Vue.use(require('vue-moment'));
Vue.use(VueLoading);
Vue.use(Vuex);


Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

const app = new Vue({
  // el: '#app',
  router,
  resetcss,
  css,
  store,
  components: { App },
  template: '<App/>'
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js